<img [src]="sanitizer.bypassSecurityTrustResourceUrl(src)" title="{{data}}" [ngClass]="{'rounded-circle': circle}">